export default __webpack_public_path__ + "postMock-1745897679998.html";